import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Menu, Bell } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useNewOrdersPolling } from '../../hooks/useNewOrdersPolling';

export default function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useAuth();
  const { newOrdersCount, clearCount } = useNewOrdersPolling();

  return (
    <div className="flex h-screen bg-brand-bg font-body" data-testid="dashboard-layout">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        newOrdersCount={newOrdersCount}
        onClearOrders={clearCount}
      />

      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-200 ${collapsed ? 'ml-0' : 'ml-64'}`}>
        {/* Top bar */}
        <header className="bg-white border-b border-brand-border px-6 py-3 flex items-center gap-4 flex-shrink-0">
          <button onClick={() => setCollapsed(!collapsed)} className="p-2 rounded-lg hover:bg-brand-bg" data-testid="sidebar-toggle">
            <Menu className="w-5 h-5 text-brand-text-muted" />
          </button>
          <div className="flex-1" />
          {newOrdersCount > 0 && (
            <button
              onClick={clearCount}
              className="p-2 rounded-lg hover:bg-brand-bg relative"
              title={`${newOrdersCount} novo(s) pedido(s)`}
              data-testid="bell-new-orders"
            >
              <Bell className="w-5 h-5 text-brand-primary" />
              <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                {newOrdersCount > 9 ? '9+' : newOrdersCount}
              </span>
            </button>
          )}
          {newOrdersCount === 0 && (
            <button className="p-2 rounded-lg hover:bg-brand-bg relative">
              <Bell className="w-5 h-5 text-brand-text-muted" />
            </button>
          )}
        </header>

        {/* Page content */}
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
